import React from 'react';
import {Flex, Icon, InputProps} from '@chakra-ui/react';
import {FormInputContainer} from 'components/form/FormInputContainer';
import {ValidatorWithMethods} from 'components/form/types';
import {StyledSearch} from 'components/theme/StyledSearch';
import {useTheme} from '@emotion/react';
import get from 'lodash/get';
import {SearchIcon} from '@chakra-ui/icons';
import {useFormInput} from 'components/form/utils';

export interface GeoSearchProps extends InputProps {
	name: string;
	placeholder?: string;
	validation?: ValidatorWithMethods<any>;
}

export const GeoSearch: React.FC<GeoSearchProps> = ({
	name,
	placeholder,
	validation,
	...props
}: GeoSearchProps) => {
	const {hasError, validationInContext, methods} = useFormInput({
		name,
		validation
	});
	const theme = useTheme();

	return (
		<Flex
			w='15rem'
			alignItems={'center'}
			justifyContent={'center'}
			borderRadius='3xl'
			bgColor={'#ccf1ff'}
		>
			<Icon
				as={SearchIcon}
				color={props.color ?? 'geoBlue.500'}
				marginLeft='10%'
			/>
			<FormInputContainer
				isInvalid={hasError}
				errorMessage={hasError?.message ?? '&nbsp;'}
			>
				<StyledSearch
					ref={methods?.register({
						validate: validationInContext,
						valueAsNumber: false,
						valueAsDate: false
					})}
					color={props.color ?? get(theme, 'colors.geoBlue.500')}
					bgColor={'#ccf1ff'}
					name={name}
					w={props.w}
					px={props.px ?? '0'}
					placeholder={placeholder}
					fontStyle={props.fontStyle}
					fontSize='sm'
					fontWeight={props.fontWeight ?? 'bold'}
					isInvalid={hasError}
					sx={{fontSize: props.fontSize ?? 'xs'}}
					border={props.border ?? 'none'}
					focusBorderColor={hasError ? 'label.fail' : 'inherit'}
					{...props}
					bg={props.bg ?? ''}
					_focus={{
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					}}
					_focusVisible={{
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					}}
				/>
			</FormInputContainer>
		</Flex>
	);
};
